<template>
  <Card
    :isCustomTooltip="false"
    :title="`${$t('rc_table_unavailability')} <span>${$t('rc_unavailability_update')}</span>`"
    :hint="$t('rc_opportunities_unavailability_tooltip')"
    :isActionable="false"
    type="unavailability"
  >
    <template #cardData>
      <div :class="Number(unavailabilityRate) === 100 ? 'tw:text-red-700' : 'tw:text-black'">{{ unavailability }}</div>
    </template>
  </Card>
</template>
<script setup>
import Card from '@/components/rateConnect/statusBar/Card.vue'

defineProps({
  unavailability: String,
  unavailabilityRate: [Number, String],
})
</script>
